<template>
  <BApp>
    <div class="h-100">
      <div class="d-flex h-100 overflow-hidden">
        <CollapseWrapper
          v-if="showSidebar"
          direction="left"
        >
          <LeftNavBar />
        </CollapseWrapper>
        <div class="flex-grow-1 h-100 overflow-auto main">
          <TopNavBar
            v-if="$route.path.includes($const.ROUTES.CELL)"
          />
          <router-view />
        </div>
        <LoadingSpinner v-if="isBusy" />
      </div>
    </div>
  </BApp>
</template>
<script setup lang="ts">
import { computed, watch, onMounted } from 'vue';
import LeftNavBar from '@/views/components/LeftNavBar.vue';
import LoadingSpinner from '@/views/components/widgets/LoadingSpinner.vue';
import TopNavBar from '@/views/components/TopNavBar.vue';
import CollapseWrapper from '@/components/CollapseWrapper.vue';
import { useConfigStore } from '@/store/config';
import { useMeasurementRulerStore } from '@/store/modules/measurementRuler';
import { BApp } from 'bootstrap-vue-next';
import { useConstants, useCookie, useRouterInstance } from '@/composables/useAppGlobals';

const router = useRouterInstance();
const $route = router.currentRoute;
const $const = useConstants();
const $cookie = useCookie();
const configStore = useConfigStore();
const measurementRulerStore = useMeasurementRulerStore();

const isLogin = computed(() => configStore.isLogin);
const logoutFlag = computed(() => configStore.logoutFlag);
const isBusy = computed(() => configStore.isBusy);

const showSidebar = computed(() => {
  return !$route.value.path.includes($const.ROUTES.LOGIN) && 
         !$route.value.path.includes($const.ROUTES.PASSWORD_RESET) && 
         isLogin.value;
});

const logout = () => {
  measurementRulerStore.resetSession();
  $cookie.deleteCookie($const.COOKIES.KEY.USER_TOKEN);
  $cookie.deleteCookie($const.COOKIES.KEY.USER_ID);
  $cookie.deleteCookie($const.COOKIES.KEY.USER_NAME);
  configStore.setIsLogin(false);
  configStore.resetState();
  router.push($const.ROUTES.LOGIN);
};

watch(logoutFlag, () => {
  const hasValidToken = !!$cookie.getCookie($const.COOKIES.KEY.USER_TOKEN);
  if (isLogin.value || hasValidToken) {
    logout();
  }
});

onMounted(() => {
  configStore.setIsLogin(!!$cookie.getCookie($const.COOKIES.KEY.USER_TOKEN));
});
</script>

<style lang="scss">
@use '@/assets/scss/variables' as *;
@use '@/assets/scss/main' as *;

#app {
  -webkit-font-smoothing: antialiased;
  text-align: left;
}
</style>
